import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Customer } = Mobi2Go;

const ResendCode = ({ email, send_sms = false }) => {
    const { t } = useTranslation('customer');
    const [buttonText, setButtonText] = useState(null)
    const RESEND_CODE_TIMEOUT = 10000;

    const resendCode = () => {
        setButtonText(t('resending_code'));
        Customer.ComoLoyalty.sendCode(email, send_sms, () => {
            setButtonText(t('resend_code_success'))
            setTimeout(() => {
                setButtonText(null);
            }, RESEND_CODE_TIMEOUT)
        });
    }

    return (
        <div className="m2g-form-element-group m2g-customer-details-save-button-container">
            <button
                className={`m2g-customer-forgot-password-button m2g-button m2g-form-element--full-width
                    ${!!buttonText ? ' m2g-button--disabled' : ''}
                `}
                onClick={resendCode}
                type="button"
                disabled={!!buttonText}
            >
                {buttonText ?? t('resend_code')}
            </button>
        </div>
    );
};

export default ResendCode;
